import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggle = (id: number) => {
    setOpenIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section id="faq" className="py-14 md:py-20 scroll-mt-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">帮助中心</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">关于古古漫画网使用最常被问到的问题解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div key={item.id} className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900">{item.q}</h3>
                  <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                    <i className={`text-sm ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}